export default async function fetchSvg(url: string): Promise<string> {
  const response = await fetch(url)
  const responseText = await response.text()
  const element = new DOMParser().parseFromString(responseText, 'image/svg+xml')
  const serialized = new XMLSerializer().serializeToString(element)

  return `data:image/svg+xml;base64,${window.btoa(serialized)}`
}
